// src/pages/Admin/UserInfo.jsx
import React, { useState } from "react";
import axios from "axios";

export default function UserInfo() {
  const [phone, setPhone] = useState("");
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const searchUser = async () => {
    if (!phone) return;
    setLoading(true);
    setError("");
    setUser(null);
    try {
      const res = await axios.get(`https://api.earnmoney0.top/admin/user-info/${phone}`);
      if (res.data.success) {
        setUser(res.data.user);
      } else {
        setError("❌ User not found");
      }
    } catch (err) {
      console.error(err);
      setError("⚠️ Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="user-info-page">
      <style>{`
        .user-info-page {
          min-height: 100vh;
          background-color: #0b0f1a;
          color: white;
          padding: 24px;
          font-family: sans-serif;
        }
        h1 {
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 24px;
          color: #22c55e;
        }
        .search-container {
          display: flex;
          gap: 8px;
          margin-bottom: 24px;
        }
        .search-container input {
          flex: 1;
          padding: 10px;
          border-radius: 8px;
          border: 1px solid #444;
          background: #111827;
          color: white;
          font-size: 16px;
        }
        .search-container button {
          padding: 10px 16px;
          border: none;
          border-radius: 8px;
          background: #22c55e;
          color: black;
          font-weight: 600;
          cursor: pointer;
          transition: 0.3s;
        }
        .search-container button:hover {
          background: #16a34a;
        }
        .user-card {
          background: #111827;
          padding: 20px;
          border-radius: 16px;
          max-width: 600px;
          margin-top: 16px;
        }
        .user-card div {
          margin-bottom: 12px;
        }
        .label {
          font-weight: 600;
          color: #facc15;
          width: 180px;
          display: inline-block;
        }
        .value {
          font-weight: 500;
          color: #ffffff;
        }
        .buy-package {
          display: flex;
          gap: 6px;
          flex-wrap: wrap;
        }
        .buy-package span {
          background: #6c63ff40;
          color: #6c63ff;
          padding: 4px 8px;
          border-radius: 6px;
          font-weight: 500;
          font-size: 14px;
        }
        .view-btn {
          padding: 4px 10px;
          background: #22c55e;
          color: black;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 600;
          margin-left: 8px;
        }
        .commission {
          color: #22c55e;
          font-weight: 600;
        }
        @media (max-width: 640px) {
          .user-card {
            max-width: 100%;
          }
          .label {
            width: 140px;
          }
        }
      `}</style>

      <h1>🔍 Search by User Info</h1>

      <div className="search-container">
        <input
          type="text"
          placeholder="Enter Phone Number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        <button onClick={searchUser} disabled={loading}>
          {loading ? "Searching..." : "Search"}
        </button>
      </div>

      {error && <p style={{ color: "#f87171", marginTop: 8 }}>{error}</p>}

      {user && (
        <div className="user-card">
  <div>
    <span className="label">Username:</span>
    <span className="value">{user.username}</span>
  </div>
  <div>
    <span className="label">Phone:</span>
    <span className="value">{user.phone}</span>
  </div>
  <div>
    <span className="label">Main Balance:</span>
    <span className="value">৳{user.mainBalance}</span>
  </div>
  <div>
    <span className="label">Deposit Balance:</span>
    <span className="value">৳{user.depositBalance}</span>
  </div>
  <div>
    <span className="label">Withdraw Balance:</span>
    <span className="value">৳{user.withdrawBalance}</span>
  </div>
  <div>
    <span className="label">Total Income:</span>
    <span className="value">৳{user.totalIncome}</span>
  </div>
  <div>
    <span className="label">Today Income:</span>
    <span className="value">৳{user.todayIncome}</span>
  </div>
  <div>
    <span className="label">Account Create Date:</span>
    <span className="value">
      {new Date(user.accountCreateDate).toLocaleDateString("en-GB")}
    </span>
  </div>
  <div>
    <span className="label">Account Status:</span>
    <span className="value">{user.accountStatus}</span>
  </div>
  <div>
    <span className="label">Refer Code:</span>
    <span className="value">{user.referCode}</span>
  </div>
  <div>
    <span className="label">Total Referrals:</span>
    <span className="value">{user.totalReferrals}</span>
    <button
  className="view-btn"
  onClick={() => window.location.href = `/admin/referrals/${user.referCode}`}
>
  View
</button>
          </div>
    <div>
  <span className="label">Package List:</span>
  <span className="value">
    {Array.isArray(user.purchasedPackages)
      ? user.purchasedPackages.join(" + ")
      : user.purchasedPackages}
      </span>
        </div>
        </div>
      )}
    </div>
  );
}